module.exports = __webpack_public_path__ + "media/images/instructions/gcp-billing-export-b47563e383c1868fad3a1ec522118569.png";